<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="ml-0 pl-0" />
    </v-col>
    <v-col cols="12" offset-lg="1" lg="10">
      <div class="title theme-text float-md-left">Marketplace offers</div>
      <v-btn
        v-if="userInfo.role === 'HR'"
        class="float-md-right action white--text rounded-sm"
        @click="offerManagement"
        depressed
        >Promote your offers here!</v-btn
      >
    </v-col>
    <v-col cols="12" offset-lg="1" lg="2">
      <v-card>
        <v-card-title class="theme white--text">
          <div class="body-1">Filter Offers</div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mt-4">
              <div class="body-1 theme-text">Offer type</div>
              <template v-for="(item, i) in types">
                <v-checkbox
                  :key="i"
                  class="mb-n5 py-0"
                  v-model="search.type"
                  :label="item.name"
                  :value="item.value"
                />
              </template>
              <div class="my-7">
                <template v-for="item in source">
                  <v-checkbox
                    :key="item.value"
                    class="mb-n7 py-0"
                    v-model="search.admin_benefit"
                    :label="item.name"
                    :value="item.value"
                  />
                </template>
              </div>

              <div class="body-1 theme-text mt-4">Category</div>
              <template v-if="categories">
                <v-select
                  :items="categories"
                  class="mb-n5 py-0"
                  v-model="search.category"
                  clearable
                />
              </template>

              <div class="body-1 theme-text mt-4">Location</div>
              <template v-if="allCountries">
                <v-select
                  :items="allCountries"
                  item-value="name"
                  item-text="name"
                  class="mb-n5 py-0"
                  v-model="search.location"
                  clearable
                />
              </template>

              <!--              <div class="body-1 theme-text mt-4">Coworking space</div>-->
              <!--              <template v-if="providers">-->
              <!--                <v-select :items="providers" class="mb-n5 py-0" clearable/>-->
              <!--              </template>-->

              <div class="body-1 theme-text mt-4">Sort by</div>
              <template v-if="sorting">
                <v-select
                  :items="sorting"
                  class="mb-n5 py-0"
                  v-model="search.sort"
                  clearable
                />
              </template>

              <v-btn
                block
                class="mt-4 action rounded-sm white--text"
                @click="getBenefits"
              >
                Search</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" lg="8">
      <v-row>
        <template v-for="(benefit, i) in marketplaceOffers">
          <v-col
            v-if="cardWidth(i) === 8 || cardWidth(i) === 12"
            cols="12"
            :md="cardWidth(i)"
            :key="benefit.id"
          >
            <horizontal-card :benefit="benefit" />
          </v-col>
          <v-col v-else cols="12" :md="cardWidth(i)" :key="benefit.id">
            <vertical-card :benefit="benefit" />
          </v-col>
        </template>
      </v-row>
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import HorizontalCard from "@/views/protected/benefit/marketplace/HorizontalCard";
import VerticalCard from "@/views/protected/benefit/marketplace/VerticalCard";

export default {
  name: Component.Protected.Benefit.Marketplace,
  components: {
    HorizontalCard,
    VerticalCard,
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Benefit.Marketplace,
    categories: [],
    types: Constants.Benefits.Type.Select,
    source: Constants.Benefits.Source.Select,
    search: {
      type: [],
      category: "",
      location: "",
      status: Constants.Benefits.Status.Active,
      limit: 10,
      offset: 0,
      sort: Constants.Benefits.Sorting.Newest,
      worldwide: false,
      admin_benefit: null,
    },
    pagination: { disableNext: true, page: 0 },
    benefits: [],
    sorting: Constants.Benefits.Sorting.All,
    allCountries: [],
    // providers: ['ProviderA', 'ProviderB', 'ProviderC'],
  }),
  computed: {
    ...mapGetters([
      "userInfo",
      "countries",
      "benefitList",
      "marketplaceOffers",
      "me",
      "marketplaceSearch",
    ]),
  },
  methods: {
    cardWidth(i) {
      if (i % 6 === 0) {
        return 8;
      }
      if (i % 6 === 5) {
        return 12;
      }
      return 4;
    },
    offerManagement() {
      this.$router.push({ name: Component.Protected.Benefit.Provider.Info });
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.marketplaceOffers.length <= this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getBenefits();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getBenefits();
      }
    },

    getBenefits() {
      let search = {};
      this.search.location == "Worldwide"
        ? (search = {
            ...this.search,
            type: this.search.type.length > 0 ? this.search.type.join() : "",
            location: "",
            worldwide: true,
          })
        : (search = {
            ...this.search,
            type: this.search.type.length > 0 ? this.search.type.join() : "",
          });

      // if (this.userInfo.role === Constants.Roles.HR) {
      this.$store
        .dispatch(Actions.MarketPlaceOffers.Find, search)
        .then(() => {
          let len = 0;
          if (this.marketplaceOffers) {
            len = this.marketplaceOffers.length;
            if ((len < this.search.limit && len > 0) || len === 0) {
              this.pagination.disableNext = true;
            } else if (len === this.search.limit) {
              this.pagination.disableNext = false;
            }
          }
          this.$store.dispatch(
            Actions.MarketPlaceOffers.SaveSearch,
            this.search
          );
          this.search.worldwide = false;
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.List, err);
          this.snackbarMessage = Constants.Benefits.Messages.Error.List;
          this.snackbar = true;
        });
      // }
    },
    showBenefit(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Benefit.OnBoarding,
        params: { id: id },
      });
    },
    getMe() {
      this.$store
        .dispatch(Actions.Employee.Me)
        .then((r) => {
          if (r.status === 200 && r.data) {
            const b2c = ["B2C"];
            this.search = {
              type: b2c,
              location: r.data.job_location,
              limit: 10,
              offset: 0,
              status: Constants.Benefits.Status.Active,
            };
          }
          this.getBenefits();
        })
        .catch((err) => {
          console.error(Constants.Employee.Messages.Error.Get, err);
          this.getBenefits();
        });
    },
    getInfo() {
      this.$store
        .dispatch(Actions.MarketPlaceOffers.Info)
        .then((r) => {
          this.categories = r.data.categories;
          if (this.categories.length === 0) {
            this.categories = Constants.Benefits.Category.All;
          }
        })
        .catch(() => {
          this.categories = Constants.Benefits.Category.All;
        });
    },
    getAllCountries() {
      this.$store
        .dispatch(Actions.Countries)
        .then(() => {
          this.allCountries = [...this.countries];
          this.allCountries.unshift({ name: "Worldwide" });
        })
        .catch((err) => {
          console.error("Error getting countries", err);
        });
    },
    setup() {
      // if (this.userInfo.role !== Constants.Roles.HR) {
      // this.$router.go(-1);
      // return false;
      // }
      this.getAllCountries();
      this.getInfo();
      this.$store.dispatch(Actions.MarketPlaceOffers.GetSearch);
      Object.keys(this.marketplaceSearch).length != 0
        ? ((this.search = this.marketplaceSearch), this.getBenefits())
        : this.userInfo.role === "HR"
        ? this.getBenefits()
        : this.getMe();
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>